import React from "react";
import Icon from "@ant-design/icons";
import { CustomIconComponentProps } from "@ant-design/icons/es/components/Icon";

function PackageIcon(props: Partial<CustomIconComponentProps>) {
  return (
    <Icon
      {...props}
      component={() => (
        <svg
          width={props.width || 24}
          height={props.height || 24}
          viewBox="0 0 18 19"
          fill="currentColor"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M8.25 17.1257V9.98724L2 6.36799V13.3335C2 13.3847 2.01283 13.4327 2.0385 13.4777C2.06417 13.5226 2.10258 13.561 2.15375 13.593L8.25 17.1257ZM9.75 17.1257L15.8462 13.593C15.8974 13.561 15.9358 13.5226 15.9615 13.4777C15.9872 13.4327 16 13.3847 16 13.3335V6.36799L9.75 9.98724V17.1257ZM8.09625 18.7622L1.404 14.9102C1.11933 14.7462 0.8975 14.5271 0.7385 14.2527C0.5795 13.9782 0.5 13.6769 0.5 13.3487V5.76424C0.5 5.43608 0.5795 5.13474 0.7385 4.86024C0.8975 4.58591 1.11933 4.36674 1.404 4.20274L8.09625 0.350743C8.38075 0.186576 8.682 0.104492 9 0.104492C9.318 0.104492 9.61925 0.186576 9.90375 0.350743L16.596 4.20274C16.8807 4.36674 17.1025 4.58591 17.2615 4.86024C17.4205 5.13474 17.5 5.43608 17.5 5.76424V13.3487C17.5 13.6769 17.4205 13.9782 17.2615 14.2527C17.1025 14.5271 16.8807 14.7462 16.596 14.9102L9.90375 18.7622C9.61925 18.9264 9.318 19.0085 9 19.0085C8.682 19.0085 8.38075 18.9264 8.09625 18.7622ZM12.8558 6.45649L15.175 5.12574L9.15375 1.64299C9.10258 1.61099 9.05133 1.59499 9 1.59499C8.94867 1.59499 8.89742 1.61099 8.84625 1.64299L6.675 2.89299L12.8558 6.45649ZM9 8.69499L11.325 7.34874L5.15 3.77949L2.825 5.12574L9 8.69499Z"
            fill="#434343"
          />
        </svg>
      )}
    />
  );
}

export default PackageIcon;
